/**
 * TanStack Query hooks for `volume-based-pricing-per-click-per-conversion`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	volumeBasedPricingPerClickPerConversionQueryKeys,
	type CreateVolumeBasedPricingPerClickPerConversionBody,
	type ListVolumeBasedPricingPerClickPerConversionResponse,
	type VolumeBasedPricingPerClickPerConversionRow,
} from "./api";

export function useVolumeBasedPricingPerClickPerConversionList(): UseQueryResult<ListVolumeBasedPricingPerClickPerConversionResponse, Error> {
	return useQuery({
		queryKey: volumeBasedPricingPerClickPerConversionQueryKeys.list(),
		queryFn: list,
	});
}

export function useVolumeBasedPricingPerClickPerConversionCreate(): UseMutationResult<VolumeBasedPricingPerClickPerConversionRow, Error, CreateVolumeBasedPricingPerClickPerConversionBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: volumeBasedPricingPerClickPerConversionQueryKeys.all });
		},
	});
}

export function useVolumeBasedPricingPerClickPerConversionDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: volumeBasedPricingPerClickPerConversionQueryKeys.all });
		},
	});
}
